var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.theme.isDark}},[_c('div',{staticClass:"app-layout"},[_c('room-navigation'),_c('router-view')],1),_c('error-message',{model:{value:(_vm.errorData),callback:function ($$v) {_vm.errorData=$$v},expression:"errorData"}}),_c('info-modal'),_c('room-info-dialog'),_c('confirmation-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }